import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { auth } from "../firebaseConfig";
import { signOut } from "firebase/auth";
import { ref, onValue } from "firebase/database";
import { database } from "../firebaseConfig";

const WorldDbHeader = ({ activeView, setActiveView }) => {
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [userName, setUserName] = useState('No Name');
  const [userEmail, setUserEmail] = useState('No Email');
  const [userPhoto, setUserPhoto] = useState('');
  const [hasAgency, setHasAgency] = useState(false);
  const [isPremium, setIsPremium] = useState(false);

  const handleSignOut = () => {
    signOut(auth).then(() => {
      console.log("Erfolgreich abgemeldet!");
    }).catch((error) => {
      console.error("Fehler beim Abmelden:", error);
    });
  };

  useEffect(() => {
    if (auth.currentUser) {
      setUserEmail(auth.currentUser.email || 'No Email');
    }
  }, [auth.currentUser]);

  useEffect(() => {
    if (auth.currentUser) {
      setUserName(auth.currentUser.displayName || 'No Name');
      setUserEmail(auth.currentUser.email || 'No Email');
    }
  }, [auth.currentUser]);

  useEffect(() => {
    const userId = auth.currentUser?.uid;
    if (userId) {
      const userPhotoRef = ref(database, `Users/${userId}/userPhoto`);
      const userAgencyRef = ref(database, `Users/${userId}/hasAgency`);
      const userPremiumRef = ref(database, `Users/${userId}/isPremium`);

      onValue(userPhotoRef, (snapshot) => {
        if (snapshot.exists()) {
          setUserPhoto(snapshot.val());
        }
      });

      onValue(userAgencyRef, (snapshot) => {
        if (snapshot.exists()) {
          setHasAgency(snapshot.val());
        }
      });

      onValue(userPremiumRef, (snapshot) => {
        if (snapshot.exists()) {
          setIsPremium(snapshot.val());
        }
      });
    }
  }, []);

  return (
    <div className="dashboard-header">
      <div className="logo-and-menu">
        <NavLink to="/" style={{ textDecoration: 'none'}}>
          <div className="header_logo_1">
            <img src="/img/BonusClub_Logo.webp" alt="" />
          </div>
        </NavLink>
      </div>

      <div className="dashboard_header_links">
        <div 
          className={`menu-item ${activeView === "tableOne" ? "selector" : ""}`}
          onClick={() => setActiveView("tableOne")}
        >
          <div>
            <img className="invisible_icon" src="/img/target.svg" alt="" />
            <p>Targets <span>AI</span></p>
          </div>
        </div>

    
  
        <div 
          className={`menu-item ${activeView === "smartInbox" ? "selector" : ""}`}
          onClick={() => setActiveView("smartInbox")}
        >
          <div>
            <img className="invisible_icon" src="/img/mailbox.svg" alt="" />
            <p>Inbox  <span>AI</span></p>
          </div>
        </div>

        <div 
          className={`menu-item ${activeView === "offerCreator" ? "selector" : ""}`}
          onClick={() => setActiveView("offerCreator")}
        >
          <div>
            <img className="invisible_icon" src="/img/bag.svg" alt="" />
            <p>Deal Wizard</p>
          </div>
        </div>

        {/* <div 
          className={`menu-item ${activeView === "payouts" ? "selector" : ""}`}
          onClick={() => setActiveView("payouts")}
        >
          <div>
            <img className="invisible_icon" src="/img/launch.svg" alt="" />
            <p>Payouts</p>
          </div>
        </div> */}
        <div 
          className={`menu-item ${activeView === "settings" ? "selector" : ""}`}
          onClick={() => setActiveView("settings")}
        >
          <div>
            <img className="invisible_icon" src="/img/setting-3.svg" alt="" />
            <p>Settings</p>
          </div>
        </div>
      </div>

      <div className="profile-section">
        <div className="profile-section-wrapper" onClick={() => setShowProfileMenu(!showProfileMenu)}>
          <img 
            src="/img/menu_1.svg" 
            alt="Menu" 
            className={`profile-pic-2 ${showProfileMenu ? 'profile-pic-rotate' : ''}`}
          />
          <img 
            src={userPhoto || "/img/user-three.svg"}
            alt="Profile" 
            className="profile-pic"
          />
          {showProfileMenu && (
            <div className="profile-menu">
              <div className="profile-menu-info">
                <div className="profile-menu-item-2">{userName}</div>
                <div className="profile-menu-item-3">{userEmail}</div>
              </div>
              
              {hasAgency && (
                <div className="question-right-pro-6" style={{right: '135px', top: '8px'}}>
                  <img className="crown" src="/img/diamond.svg" alt="Pro"/>
                  <p>CLUB</p>
                </div>
              )}

              {isPremium && !hasAgency && (
                <div className="question-right-pro-6" style={{right: '135px', top: '8px'}}>
                  <img className="crown" src="/img/crow.svg" alt="Pro"/>
                  <p>PRO</p>
                </div>
              )}

              <div className="dashboard-menu-slice">
                <img src="/img/edit.svg" alt="link settings" />
                <NavLink to="/user-settings">Edit Profile</NavLink>
              </div>

              <div className="dashboard-menu-slice" style={{marginTop: '-5px'}}>
                <img src="/img/qr.svg" alt="link settings" />
                <NavLink to="/">QR Codes</NavLink>
              </div>

              <div className="dashboard-menu-slice" style={{marginTop: '-5px'}}>
                <img src="/img/mailbox.svg" alt="link settings" />
                <a href="https://bonusclub.io" target="_blank" rel="noopener noreferrer">Contact Us</a>
              </div>

              <NavLink className="sign_out" to="/login" onClick={handleSignOut}>Sign Out</NavLink>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WorldDbHeader; 